<template>
  <base-container>
    <el-form
      ref="elForm"
      :model="form"
      :rules="rules"
      size="medium"
      label-width="100px"
    >
      <el-form-item label="主标题" prop="title">
        <el-input
          v-model="form.title"
          placeholder="请输入主标题"
          :maxlength="100"
          show-word-limit
          clearable
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item label="协议内容" prop="content">
        <Tinymce ref="editor" v-model="form.content" height="400" />
      </el-form-item>
      <el-form-item label="备注" prop="comment">
        <el-input
          v-model="form.comment"
          placeholder="请输入单行文本"
          clearable
          show-word-limit
          :maxlength="30"
          :style="{ width: '100%' }"
        />
      </el-form-item>
      <el-form-item size="small">
        <el-button type="primary" class="mr8" @click="handleSubmit">提交</el-button>
        <el-button @click="resetForm">重置</el-button>
      </el-form-item>
    </el-form>
  </base-container>
</template>
<script>
/**
 * 内容管理-协议管理-新增or更新
 */
import { addOrUpdateFaq, getFaqInfo } from '@/api/content'
import Tinymce from '@/components/Tinymce'
import { ROUTER_FAQ_LIST } from './const'
export default {
  name: 'HelpCenterDetailAdd',
  components: {
    Tinymce
  },
  props: [],
  data() {
    return {
      form: {
        id: null,
        title: '',
        content: null,
        comment: ''
      },
      rules: {
        title: [
          {
            required: true,
            message: '请输入主标题',
            trigger: 'blur'
          }
        ],
        type: [
          {
            required: true,
            message: '请选择协议类型',
            trigger: 'change'
          }
        ],
        content: [
          {
            required: true,
            message: '请输入协议内容',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {
    this.initForm()
  },
  methods: {
    goBack() {},
    handleSubmit() {
      this.$refs['elForm'].validate((valid) => {
        if (!valid) return
        const { form } = this
        // TODO 提交表单
        addOrUpdateFaq(form).then((res) => {
          if (res.code === '00000') {
            this.$message({
              type: 'success',
              message: '添加成功',
              onClose: () => {
                this.$router.push({ path: ROUTER_FAQ_LIST })
              }
            })
          }
        })
      })
    },
    resetForm() {
      this.$refs['elForm'].resetFields()
    },
    initForm() {
      const { id } = this.$route.query
      if (id) {
        getFaqInfo({ id }).then(res => {
          this.form = res.data
        }).catch(() => {
          this.$refs['elForm'].resetFields()
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.agreement-container {
  margin: 10px;
  background: #fff;
  min-height: 768px;
  .add-agreement-container {
    padding-top: 50px;
    display: flex;
    justify-content: center;
  }
}
</style>

